export default {
	setToken(data) {
		window.localStorage.setItem('auth_two_factor', data);
	},
	getToken() {
		return window.localStorage.getItem('auth_two_factor');
	},
	removeToken() {
		window.localStorage.removeItem('auth_two_factor');
	}
}